// src/page/Patient/contents/scan-mini/component/report/ReportLanguageContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

import { en } from './translations/en';
import { ko } from './translations/ko';

type Language = 'ko' | 'en';

type Translations = typeof ko;

export type SectionType = 'summary' | 'summaryPlot' | 'architecture' | 'posture' | 'heart' | 'breathing' | 'snoring';

const translations: Record<Language, Translations> = {
  ko,
  en,
};

interface ReportLanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations['report'];
  sections: SectionType[];
  setSections: (sections: SectionType[]) => void;
}

const ReportContext = createContext<ReportLanguageContextType | undefined>(undefined);

export const ReportLanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('ko');

  const t = translations[language].report;
  const [sections, setSections] = useState<SectionType[]>([
    'summary',
    'summaryPlot',
    'architecture',
    'posture',
    'heart',
    'breathing',
    'snoring',
  ]);
  return (
    <ReportContext.Provider value={{ language, setLanguage, t, sections, setSections }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReport = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReportLanguage must be used within ReportLanguageProvider');
  }
  return context;
};
